export function calculateGSTFromInclusive(salePrice, quantity, gstPercentage) {
  const totalSalePrice = salePrice * quantity;
  const gstMultiplier = 1 + gstPercentage / 100;
  const basePrice = totalSalePrice / gstMultiplier;
  const gstAmount = totalSalePrice - basePrice;
  const cgst = gstAmount / 2;
  const sgst = gstAmount / 2;

  return {
    base_price: Math.round(basePrice * 100) / 100,
    cgst_amount: Math.round(cgst * 100) / 100,
    sgst_amount: Math.round(sgst * 100) / 100,
    total_amount: Math.round(totalSalePrice * 100) / 100,
  };
}

export function calculateInvoiceTotals(items) {
  let subtotal = 0;
  let totalGST = 0;
  let grandTotal = 0;

  items.forEach((item) => {
    subtotal += item.base_price;
    totalGST += item.cgst_amount + item.sgst_amount;
    grandTotal += item.total_amount;
  });

  return {
    subtotal: Math.round(subtotal * 100) / 100,
    total_gst: Math.round(totalGST * 100) / 100,
    grand_total: Math.round(grandTotal * 100) / 100,
  };
}
